import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

function TabPanel(props) {
    const {children, value, index, ...other } = props

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box p={3} style={{padding:'0px'}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        
    },
}))

export default function SimpleTabs(props) {
    const classes = useStyles()
    const [value, setValue] = React.useState(0)
    const { itemOne, itemTwo, itemThree, mobile } = props
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    return (
        <div className={classes.root}>
            <AppBar position="static" style={{ backgroundColor: mobile ? '#c1d0e2' : '#4c4c78', color: mobile ? 'black' : '#fff'}}>
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="Reservations" {...a11yProps(0)} />
                    <Tab label="Availibility" {...a11yProps(1)} />
                    <Tab label="Add Trip" {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                {itemOne}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {itemTwo}
            </TabPanel>
            <TabPanel value={value} index={2}>
                {itemThree}
            </TabPanel>
        </div>
    )
}
